// <br> tag with display: block on desktop and display: none on mobile
import { styled } from '~/stitches.config'

export const Break = styled('br', {
  display: 'none',
  '@bp1': {
    display: 'block',
  },
})
